export default () => ({
    root: {
        marginTop: 5,
    },
});
